var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotiSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5522_46220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.035 18.3332C5.43999 18.3332 1.70166 14.5948 1.70166 9.99984C1.70166 5.40484 5.43999 1.6665 10.035 1.6665C14.63 1.6665 18.3683 5.40484 18.3683 9.99984C18.3683 14.5948 14.63 18.3332 10.035 18.3332ZM10.035 3.33317C6.35916 3.33317 3.36833 6.324 3.36833 9.99984C3.36833 13.6757 6.35916 16.6665 10.035 16.6665C13.7108 16.6665 16.7017 13.6757 16.7017 9.99984C16.7017 6.324 13.7108 3.33317 10.035 3.33317Z",
    fill: "#1AA04B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33401 14.1065L5.96484 10.7374L7.43734 9.26402L9.06818 10.894L12.5198 6.06152L14.2157 7.27236L9.33401 14.1065Z",
    fill: "#1AA04B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5522_46220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiSuccess);
export default __webpack_public_path__ + "static/media/noti_success.a9f9aa0326c51555b494035caf30997b.svg";
export { ForwardRef as ReactComponent };